// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__6A2zB","panel":"NotFound_panel__3bRnz"};